import { EmojiAnimationsContext } from '@src/contexts';
import { useContext } from 'react';

const useEmojiAnimations = () => {
  const context = useContext(EmojiAnimationsContext);
  if (!context) {
    throw new Error('useEmojiAnimations must be a child of EmojiAnimationsProvider');
  }

  return context;
};

export default useEmojiAnimations;
